module.exports = __webpack_public_path__ + "static/img/weekly-results.19ad44d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/weekly-results.png
// module id = 0TBX
// module chunks = 1